// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"79c5a001","7077":"7b68288f","8556":"9f25c5a7"}[chunkId] + ".chunk.css";
};